import React, { ReactNode } from "react";
import { Box, Container,  } from "@mantine/core";

import HealthConnectBrandingimage from "../assets/img/HealthConnectBranding.svg";

interface BrandingPageLayoutProps {
  children: ReactNode;
}

const BrandingPageLayout: React.FC<BrandingPageLayoutProps> = (props) => {

  return (
    <Container fluid h={50} style={{ maxWidth: "1440px", margin: "0 auto" }}>
      <Box
        style={{
          display: "flex",
          flexDirection: "row",
          height: "100vh",
          width: "100%",
          objectFit: "cover",
        }}
      >
        <Box
          style={{
            display: "flex",
            objectFit: "cover",

            width: "100%",
          }}
        >
          <img
            src={HealthConnectBrandingimage}
            alt="HealthConnectBranding"
            style={{
              height: "100%",
              objectFit: "cover",
              width: "100%",
            }}
          />
        </Box>

        <Box
          style={{
            width: "100%",
            height: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          {props.children}
        </Box>
      </Box>
    </Container>
  );
};

export default BrandingPageLayout;
